import Vue from 'vue'
import Vuex from 'vuex'
import Question from './questions'
import Checkout from './checkout'
import CookieWarning from './cookie-warning'
import Customer from './customers'
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    question: Question,
    checkout: Checkout,
    customer: Customer,
    cookieWarning: CookieWarning
  },
  plugins: [
        createPersistedState({
            paths: []
        })
    ],
})
